export function ticketsByCourseCategories() {
    let $cat_courses = $('.cat-courses');
    if ($cat_courses.length) {
        let _form = $('.filter-tickets-cat-course');
        if (_form.length > 0) {
            let $list_tickets = $("ul.list-tickets-cat-course li.item-ticket");
            let $no_search = $('li.not-search-teckets');
            let flag = true;
            let flag_load = false;

            $list_tickets.each(function () {
                let _this = $(this);

                if (!_this.hasClass('hide')) {
                    flag = false;
                    return false;
                }
            });

            if (flag) {
                $no_search.removeClass('hide');
            }

            //Button load more
            $list_tickets.each(function () {
                let _this = $(this);

                if (_this.hasClass('hide-load')) {
                    flag_load = true;
                    return false;
                }
            });

            if (flag_load) {
                $('.load-more-tickets').addClass('show');
            }

            $('.load-more-tickets').on('click', function (e) {
                e.preventDefault();

                $list_tickets.removeClass('hide-load');
                $('.load-more-tickets').removeClass('show');
            });

            _form.on('change', 'select', function () {
                let form = $(this).parents(".filter-tickets-cat-course");
                let course = form.serializeArray()[0]['value'];
                let location = form.serializeArray()[1]['value'];
                let month = form.serializeArray()[2]['value'];
                let year = form.serializeArray()[3]['value'];

                $no_search.addClass('hide');

                //Button load more
                $list_tickets.removeClass('hide-load');
                $('.load-more-tickets').removeClass('show');

                let flag = true;
                let flag_load = false;

                $list_tickets.addClass('hide').each(function () {
                    let _this = $(this);
                    let arrMonth = $.parseJSON(_this.attr('data-month'));
                    let arrYear = $.parseJSON(_this.attr('data-year'));

                    if ((_this.attr('data-course') === course || course === 'all') &&
                        (_this.attr('data-location') === location || location === 'all') &&
                        ($.inArray(parseInt(month), arrMonth) !== -1 || month === 'all') &&
                        ($.inArray(parseInt(year), arrYear) !== -1 || year === 'all')) {
                        _this.removeClass('hide');

                        flag = false;
                    }
                });

                if (flag) {
                    $no_search.removeClass('hide');
                }

                $("ul.list-tickets-cat-course li.item-ticket:not(.hide)").each(function (index) {
                    let _this = $(this);

                    if (index > 4) {
                        flag_load = true;
                        _this.addClass('hide-load');
                    }
                });

                if (flag_load) {
                    $('.load-more-tickets').addClass('show');
                }
            });
        }
    }

    // let link = $('.btn-promo');
    // let promo = link.attr('data-promo');
    // let temp = $("<input>");
    //
    // link.on('click', function (e) {
    //     e.preventDefault();
    //     $("body").append(temp);
    //     temp.val(promo).select();
    //     document.execCommand("copy");
    //     temp.remove();
    //     link.text("Copied!");
    // });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tickets_by_course_categories.js